module.exports = __webpack_public_path__ + "officialStatic/img/product-kfxt.c3074bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-kfxt.png
// module id = g9Az
// module chunks = 0